import React from 'react'
import { Link } from 'react-router-dom'

import check_circle from '../../../assets/check-circle.png'
import girl_book from '../../../assets/girl-book.png'
import wheel from '../../../assets/FeemFundy-Icon-B1.png'

const HomeInfo = () => {
	const feats = [
		'Professional Review',
		'Full Production Support',
		'Expert Script Analysis',
		'Top Production Executive',
	]

	return (
		<>
			<section className='homepage_info'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-5'>
							<div className='homepage_girl_book'>
								<img src={girl_book} alt='' className='' />
							</div>
						</div>
						<div className='col-md-7' style={{ position: 'relative' }}>
							<img src={wheel} alt='Film wheel icon' className='wheel' />
							<div>
								<h3>
									FeemFUNDY is a crowdfunding platform where African filmmakers
									and funders collaborate to tell our African stories.
								</h3>
								<p>
									<strong>Process:</strong> Filmmakers come to the platform and
									do a video and/or ppt pitch of their film and the public
									crowdfunds them. The platform also gives access to production
									resources (cast, crew, equipment, accommodation, locations,
									etc). Pls feel free to do research about some of the key film
									ecosystem members.
								</p>
								<div className='mt-4'>
									{feats.map((feat) => (
										<div className='d-flex' key={feat[0]}>
											<img
												src={check_circle}
												alt='circle-check icon'
												className='check_circle'
											/>
											<span> {feat} </span>
										</div>
									))}
								</div>

								<Link
									to='/about-us'
									className='btn homepage_btn'
									style={{ display: 'inline-block' }}
								>
									Read More
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default HomeInfo
